import qsa from "1dr-utils/helpers/elsForEach";
import FormPoster from "@/js/libs/formPoster";
import { ErrorsGroup } from "@/js/libs/form-errors";
import summary from "@/js/parts/checkout/refreshSummary";
import cartStates from "@/js/parts/checkout/cartStates";

export default function (formId, callback) {

  let Form = new FormPoster({
    form: "#" + formId,
    states: {
      ready: function () {
        cartStates.ready();
        summary.ready();
      },
      loading: function () {
        cartStates.loading();
        summary.loading();
      },
    },
  });

  if (!Form.ready) {
    return false;
  }

  var checkFields = document.querySelectorAll("[data-form=" + formId + "]");
  var errors = new ErrorsGroup(checkFields);

  // append inline fields to error checking:
  var els = Form.form.querySelectorAll("input, select:not(.passive), textarea");
  qsa(els, (el) => {
    errors.add(el);
  });

  // For all fields, validate on change event:
  errors.forEach((input) => {
    // input is an instance of InputErrors
    input.on("change", () => {
      input.validate(true);
    });
  });

  Form.validateOnSubmitButtons(errors);

  Form.onSubmit(function (e) {
    // Stop page submitting:
    e.preventDefault();

    // True => Report errors
    var isValid = errors.validate(true);

    if (!isValid) {
      errors.focusFirstError();
      return;
    }

    // Make the page look like it's loading:
    this.states.loading();

    // Get a fresh bundle of data:
    this.scrapefields("[data-form=" + formId + "]");
    this.updateFormValues();

    // AJAX Post the form...
    this.post(
      (json) => {
        callback(json, Form, this.states.ready);
      },
      null,
      (error) => {
        console.log(error);
      },
    );
  });

  return Form;
}
